import { Button, notification, Space } from 'antd';

type NotificationType = 'success' | 'info' | 'warning' | 'error';
export const openNotification = (type: NotificationType, title: string, description: string) => {
  notification[type]({
    message: title,
    description
  });
};
